export default __webpack_public_path__ + "static/media/IMG7.40e3134f.png";